import { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { Icon } from "@/components/ui/Icon";
import { ROUTES } from "@/constants/routes";
import { useAuth } from "@/hooks/useAuth";

import { AdminLayout } from "./AdminLayout";

export const AdminGuard = () => {
  const { user, isLoading, isAuthenticated, logout } = useAuth();
  const isAdmin = user?.role?.toLowerCase() === "admin";

  useEffect(() => {
    if (!isLoading && isAuthenticated && !user) {
      logout();
    }
  }, [isLoading, isAuthenticated, user, logout]);

  // Если не авторизован — на логин
  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.login}
        replace
      />
    );
  }

  if (isLoading) {
    return (
      <div className="bg-background flex h-screen w-full items-center justify-center">
        <Icon
          name="spinner"
          className="size-6 animate-spin text-neutral-500"
        />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  // Если не админ — на дашборд
  if (!isAdmin) {
    return (
      <Navigate
        to={ROUTES.dashboard}
        replace
      />
    );
  }

  return <AdminLayout />;
};
